module.exports = __webpack_public_path__ + "static/media/event_meditation.ae6f947d.jpg";